import {BaseResponse} from './internal/baseresponse';
import {PayoutBranch} from './internal/list/agentlistresult';
export class BranchDetailResult extends BaseResponse {
  data?: PayoutBranch;
}


export class BranchListResult extends BaseResponse {
  data?: Array<PayoutBranch> = new Array<PayoutBranch>();
}



// WEBPACK FOOTER //
// ./src/app/response/branchdetailresult.ts